import { useContext } from "react";
import { useSWRConfig } from "swr";
import { StatusHandleClientButtons } from "~/components/common/statuses/StatusHandleClientButtons";
import { ScheduleInputNavigation } from "~/components/common/visit_schedule/ScheduleInputNavigation";
import { useDealContext } from "~/context/DealContext";
import { dealCacheKey } from "~/hooks/useDeals";
import { ESTIMATION_BY } from "~/models/Deal";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import {
	IN_ESTIMATION,
	NOW_ACCEPTING,
	OWN_IN_ESTIMATION,
	ownStatusMovingValidation,
	SEND_ESTIMATE,
	statusMovingValidation
} from "~/models/Status";
import Styles from "./statuses.module.scss";

export function NowAccepting() {
	const deal = useDealContext();
	const { mutate: globalMutate } = useSWRConfig();
	const account = useContext(ItandiAccountContext);
	return (
		<div>
			{deal.dealVendorCompanies.length === 0 ? (
				<>
					<h3 className={Styles.Title}>施工会社を選択してください</h3>
					<StatusHandleClientButtons
						forwardDisabled
						nextStatusId={SEND_ESTIMATE}
					/>
				</>
			) : (
				<>
					{deal.dealVendorCompanies[0].vendorCompany === null ? (
						<>
							<h3 className={Styles.Title}>ステータスを進めてください</h3>
							<StatusHandleClientButtons
								forwardDisabled={
									!ownStatusMovingValidation[OWN_IN_ESTIMATION](account)
								}
								nextStatusId={OWN_IN_ESTIMATION}
							/>
						</>
					) : deal.estimationBy === ESTIMATION_BY.COMPANY ? (
						<>
							<h3 className={Styles.Title}>ステータスを進めてください</h3>
							<StatusHandleClientButtons
								forwardDisabled={
									!statusMovingValidation[NOW_ACCEPTING](deal, account)
								}
								nextStatusId={IN_ESTIMATION}
							/>
						</>
					) : (
						<>
							<h3 className={Styles.Title}>
								施工会社がステータスを進めるまでお待ち下さい
							</h3>
							{deal.inspectionBy === "company" && (
								<ScheduleInputNavigation
									deal={deal}
									handleMutate={async (): Promise<void> => {
										await globalMutate(dealCacheKey(deal.id));
									}}
								/>
							)}
							<StatusHandleClientButtons
								forwardDisabled
								nextStatusId={IN_ESTIMATION}
							/>
						</>
					)}
				</>
			)}
		</div>
	);
}
